import React from "react";
/** Components Import */
import Section from "../../Components/Section";
import Card from "../../Components/Card_wrap";
import AuthGroupButton from "../../Components/Button_Auth_Group";
import BasicCombo from "../../Components/Combo_Basic";
import BasicInput from "../../Components/Input_Basic";
import BasicModal from "../../Components/Modal_Basic";
import Checking from "../../Components/Checking";
import DatePicker from "../../Components/Datepicker_Basic";

/** Ag-grid Import */
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import GridFunctions from "../../Services/agGrid/ag-Grid-functions";
import Commons from "../../Services/Common/Common";

function SM10021(props) {
  const gridRef = React.useRef();
  const autoGroupColumnDef = React.useMemo(() => {
    //그룹설정
    return {
      headerName: "창고명",
      minWidth: 150,
    };
  }, []);
  const rowGroupPanelShow = "always";
  const groupDefaultExpanded = 1;
  const columnDefs = [
    //창고명
    {
      field: "whNm",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_WhNm" && f.lanType === "COL"
            )[0].lanName
          : "",
      // cellRenderer: (e) => {
      //   return !e.data ? "TOTAL" : e.data.plantNm;
      // },
      rowGroup: true,
      enableRowGroup: true,
      hide: true,
      minWidth: 100,
      cellRenderer: Commons.CustomWhCdRenderer,
    },
    //사업장
    {
      field: "plantNm",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_PlantCd" && f.lanType === "COL"
            )[0].lanName
          : "",
      // cellRenderer: (e) => {
      //   return !e.data ? "TOTAL" : e.data.plantNm;
      // },
      // rowGroup: true,
      enableRowGroup: true,
      // hide: true,
      minWidth: 100,
      cellRenderer: Commons.CustomPlantRenderer,
    },
    //주문일자
    {
      field: "contractDt",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_SoDate" && f.lanType === "COL"
            )[0].lanName
          : "",
      // rowGroup: props.inputs.comboValue === "ContractDt" ? true : false,
      // hide: props.inputs.comboValue === "ContractDt" ? true : false,
      minWidth: 100,
      enableRowGroup: true,
    },
    //납기번호
    {
      field: "soDueNo",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_SoDueNo" && f.lanType === "COL"
            )[0].lanName
          : "",
      minWidth: 100,
    },
    //납기일
    {
      field: "soDueDt",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_SoDueDt" && f.lanType === "COL"
            )[0].lanName
          : "",
      minWidth: 100,
      enableRowGroup: true,
    }, //작업지시일
    {
      field: "workDt",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_WkInstrucDt" && f.lanType === "COL"
            )[0].lanName
          : "",
      minWidth: 130,
    },
    //상태
    {
      field: "stusNm",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_StatusName" && f.lanType === "COL"
            )[0].lanName
          : "",
      minWidth: 110,
      cellRenderer: Commons.CustomHeaderRenderer,
    },
    //거래처
    {
      field: "custNm",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_CustNm" && f.lanType === "COL"
            )[0].lanName
          : "",
      // rowGroup: props.inputs.comboValue === "CustNm" ? true : false,
      // hide: props.inputs.comboValue === "CustNm" ? true : false,
      minWidth: 160,
      enableRowGroup: true,
    },

    //품목명
    {
      field: "itemNm",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemNm" && f.lanType === "COL"
            )[0].lanName
          : "",
      minWidth: 300,
      enableRowGroup: true,
      // rowGroup: props.inputs.comboValue === "ItemCd" ? true : false,
      // hide: props.inputs.comboValue === "ItemCd" ? true : false,
    },
    //주문수량
    {
      field: "itemQty",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemQty" && f.lanType === "COL"
            )[0].lanName
          : "",
      valueFormatter: (params) => {
        var formatted = params.value
          ? params.value
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : "0";
        return formatted;
      },
      cellStyle: { textAlign: "right" },
      aggFunc: "sum",
      minWidth: 110,
    },
    //작업수량
    {
      field: "WorkQty",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_WorkingQuantity" && f.lanType === "COL"
            )[0].lanName
          : "",
      valueFormatter: (params) => {
        var formatted = params.value
          ? params.value
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : "0";
        return formatted;
      },
      cellStyle: { textAlign: "right" },
      aggFunc: "sum",
      minWidth: 110,
    },
    //차이
    {
      field: "difference",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_Difference" && f.lanType === "COL"
            )[0].lanName
          : "0",
      cellStyle: { textAlign: "right" },
      aggFunc: "sum",
      minWidth: 110,
    },
    //단위
    {
      field: "itemUnit",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemUnit" && f.lanType === "COL"
            )[0].lanName
          : "",
      editable: false,
      minWidth: 110,
    },
    //기준단가
    {
      field: "itemStdAmt",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemStdAmt" && f.lanType === "COL"
            )[0].lanName
          : "",
      valueFormatter: (params) => {
        var formatted = params.value
          ? params.value
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : "0";
        return formatted;
      },
      cellStyle: { textAlign: "right" },
      aggFunc: "sum",
      minWidth: 110,
    },
    //발주단가(VAT)
    {
      field: "poItemCost",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_PoItemCost" && f.lanType === "COL"
            )[0].lanName
          : "",
      valueFormatter: (params) => {
        var formatted = params.value
          ? params.value
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : "0";
        return formatted;
      },
      cellStyle: { textAlign: "right" },
      aggFunc: "sum",
      minWidth: 150,
    },
    //원화금액
    {
      field: "poWonAmt",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_SoItemAmt" && f.lanType === "COL"
            )[0].lanName
          : "",
      minWidth: 110,
      editable: false,
      valueFormatter: (params) => {
        var formatted = params.value
          ? params.value
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : "0";
        return formatted;
      },
      cellStyle: { textAlign: "right" },
      aggFunc: "sum",
      cellClass: "numberType",
    },
    //부과세여부
    {
      field: "itemVatYn",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemVatYn" && f.lanType === "COL"
            )[0].lanName
          : "", //부가세여부
      editable: false,
      minWidth: 140,
      cellStyle: { textAlign: "center" },
    },
    //주문번호
    {
      field: "soNo",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_SoNo" && f.lanType === "COL"
            )[0].lanName
          : "",
      // rowGroup: props.inputs.comboValue === "SoNo" ? true : false,
      // hide: props.inputs.comboValue === "SoNo" ? true : false,
      minWidth: 110,
    },
    //거리처코드
    {
      field: "custCd",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_CustCd" && f.lanType === "COL"
            )[0].lanName
          : "",

      minWidth: 110,
    },
    //품목코드
    {
      field: "itemCd",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemCd" && f.lanType === "COL"
            )[0].lanName
          : "",
      minWidth: 120,
    },
  ];

  return (
    <div>
      <Card
        wrapStyle={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <DatePicker
            className={"datepicker-custom-input"}
            style={{ width: "120px", marginRight: "5px" }}
            selected={props.startDate}
            onChange={(e) => {
              props.setStartDate(e);
            }}
          />
          ~
          <DatePicker
            className={"datepicker-custom-input"}
            style={{ width: "120px", marginLeft: "5px" }}
            selected={props.endDate}
            onChange={(e) => {
              props.setEndDate(e);
            }}
          />
        </div>

        <AuthGroupButton
          pageName="SM10020"
          target="G01"
          refreshNone="none"
          refreshFunc={() => {
            props.Init();
          }}
          addFunc={() =>
            // gridRef.current.api.setRowData([{}, ...props.rowData])
            props.setModalToggle(true)
          }
          selectFunc={() => {
            props.Init();
          }}
          saveFunc={() => props.SaveConfirm()}
          deleteFunc={() => props.DeleteConfirm()}
        />
      </Card>

      <div
        className="ag-theme-alpine no-scroll"
        style={{ width: "100%", height: "770px" }}
      >
        <AgGridReact
          ref={gridRef}
          animateRows={true}
          columnDefs={columnDefs}
          // groupDefaultExpanded={groupDefaultExpanded}
          rowGroupPanelShow={rowGroupPanelShow}
          // groupIncludeTotalFooter={true}
          autoGroupColumnDef={autoGroupColumnDef}
          suppressAggFuncInHeader={true} //헤더컬럼에 sum제거
          // autoSizeAll={autoSizeAll()}
          defaultColDef={{
            flex: 1,
            editable: false,
            resizable: true,
            sortable: true,
            filter: true,
            floatingFilter: true,
          }}
          frameworkComponents={{
            customHeaderRenderer: Commons.CustomHeaderRenderer,
          }}
          onCellValueChanged={(e) =>
            GridFunctions.onCellValueChanged(
              e,
              gridRef,
              props.setChangedRowData
            )
          }
          // groupDisplayType={"custom"}
          rowData={props.rowData}
          // rowSelection="single"
          onSelectionChanged={() =>
            GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)
          }
          getRowStyle={(e) => (e.data ? GridFunctions.getRowStyle(e) : "")}
          //   getRowStyle={(e) => GridFunctions.getRowStyle(e)}
        />
      </div>
    </div>
  );
}

export default SM10021;
